import { Button, Container, If, Slider, Title } from '@/components'

import { TESTIMONIALS } from './constants'
import useCases from './hooks'

import styles from './styles.module.scss'
import Image from 'next/image'

import useClickWithScroll from '@/utils/browser/useClickWithScroll'

const Testimonials = ({
  customClass,
  isPink = false,
  buttonTextVariant,
  buttonColor,
  buttonText = 'QUERO TER RESULTADOS',
  subtitle = 'Transformação de verdade. Inspire-se nos depoimentos de quem confiou na Academia Foguete!'
}) => {
  const { isHomePage, onClickItem } = useClickWithScroll()

  const { isMobile, visibleCardIndex, listRef, onScroll, itemsRefs } =
    useCases()

  return (
    <section className={`fgt-section ${styles.cases} ${customClass}`}>
      <Container>
        <Title Tag="h2" alignText="center" variant={isPink ? 'pink' : ''}>
          O que os nossos alunos <span>falam sobre os treinos</span>
        </Title>
        <p className="fgt-subtitle">{subtitle}</p>

        <div onScroll={onScroll} ref={listRef} className={`fgt-carousel`}>
          {Object.values(TESTIMONIALS).map((item, index) => {
            return (
              <div
                className={`fgt-carousel__item`}
                key={index}
                ref={(ref) => (itemsRefs.current[index] = ref)}
              >
                <Image
                  className={styles.image}
                  src={item.path}
                  alt={item.alt}
                  width={250}
                  height={300}
                />
              </div>
            )
          })}
        </div>

        <If
          condition={isMobile}
          renderIf={
            <Slider
              section="cases"
              visibleElementIndex={visibleCardIndex}
              list={Object.values(TESTIMONIALS)}
              color="pink"
            />
          }
        />

        <div className="fgt-section__action">
          <Button
            id="btn-section-cases"
            variant={buttonColor || 'primary'}
            textVariant={buttonTextVariant}
            className={'fgt-section__action--button'}
            onClick={() => {
              onClickItem('comparePlans')
            }}
          >
            {buttonText}
          </Button>
        </div>
      </Container>
    </section>
  )
}

export default Testimonials
